var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "download-all_svg__cls-1",
    d: "M14 25h16v4H14zM22 22v-7M20 20l2 2 2-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "download-all_svg__cls-2",
    cx: 16,
    cy: 27,
    r: 0.5
  })));
}

export default SvgDownloadAll;